import { useState, useEffect, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../assets/logo.png";
import LanguageSwitcher from "./LanguageSwitcher";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import LoginIcon from "@mui/icons-material/Login";
import LogoutIcon from "@mui/icons-material/Logout";
import TourIcon from "@mui/icons-material/Tour";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import { Badge } from "@mui/material";
import { useCookies } from "react-cookie";
import { LanguageContext, LoggedInContext } from "../../Context";
import "./NavbarStyle.css";
import { loadProductsByVoucher } from "../../services/loadData";
import i18next from "i18next";

const Navbar = ({ logout }) => {
  const [cookies] = useCookies(["cart", "vouchers"]);
  const navigate = useNavigate();
  const [isScrolled, setIsScrolled] = useState(false);
  const [visitsCounts, setVisitsCounts] = useState(0);
  const [cart, setCart] = useState([]);
  const loggedIn = useContext(LoggedInContext);
  const t = useContext(LanguageContext);

  useEffect(() => {
    const fetch = async () => {
      var count = 0;

      if (cookies["vouchers"]) {
        for (const voucher of cookies["vouchers"]) {
          if (new Date(voucher.expiration_date) > new Date()) {
            const response = await loadProductsByVoucher(voucher.code);
            if (response.ok) {
              count += response.products.length;
            }
          }
        }
      }
      setVisitsCounts(count);
    };

    fetch();
  }, [cookies]);

  useEffect(() => {
    setCart(cookies["cart"] ? cookies["cart"] : []);
  }, [cookies]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const NavigateToCart = () => {
    navigate(`/cart/${i18next.language}`);
  };

  const NavigateToLogin = () => {
    navigate(`/login/${i18next.language}`);
  };

  const NavigateToVisits = () => {
    navigate(`/visits/${i18next.language}`);
  };

  const NavigateToNews = () => {
    navigate(`/news/${i18next.language}`);
  };

  const Logout = () => {
    logout();
  };

  return (
    <nav className={`navbar-class ${isScrolled ? "scrolled" : ""}`}>
      <div className="navbar-container">
        <div className="logo">
          <Link to={`/${i18next.language}`} className="link-logo">
            <img
              className="Logo-image"
              src={logo}
              alt="Logo Historiar"
              width="90"
            />
          </Link>
        </div>
        <div className="menu">
          <div className="menu-items">
            <button className="btn-light btn-navbar" onClick={NavigateToVisits}>
              <Badge
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                badgeContent={visitsCounts}
                color="error"
              >
                <TourIcon />
              </Badge>
              <span className="menu-text">&nbsp;{t("visits")}</span>
            </button>
            <button className="btn-light btn-navbar" onClick={NavigateToCart}>
              <Badge
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                badgeContent={cart.length}
                color="error"
              >
                <ShoppingCartIcon />
              </Badge>
              <span className="menu-text">&nbsp;{t("cart")}</span>
            </button>
            <button className="btn-light btn-navbar" onClick={NavigateToNews}>
              <NewspaperIcon />
              <span className="menu-text">&nbsp;{t("news")}</span>
            </button>
            {loggedIn === false && (
              <button
                className="btn-light btn-navbar"
                onClick={NavigateToLogin}
              >
                <LoginIcon />
                <span className="menu-text">&nbsp;{t("login")}</span>
              </button>
            )}
            {loggedIn && (
              <button className="btn-light btn-navbar" onClick={Logout}>
                <LogoutIcon />
                <span className="menu-text">&nbsp;{t("logout")}</span>
              </button>
            )}

            <div style={{ marginLeft: "1em" }}>
              <LanguageSwitcher />
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
